import React from "react"
import AppDrawer from "./AppDrawer/AppDrawer"

const Aside = () => <AppDrawer />


export default Aside
